import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { TableModule, Table } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule, ReactiveFormsModule, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule  } from 'primeng/toggleswitch';
import { SelectModule } from 'primeng/select';
import { LambdaService } from '../../services/lambda.service';
import { ToastModule } from 'primeng/toast';
import { format } from 'date-fns';
import { ActivatedRoute } from '@angular/router';
import { SplitButton } from 'primeng/splitbutton';
import { MessageService } from 'primeng/api';
import { TagModule } from 'primeng/tag';

interface Payment {
  name: string;
  value: string;
}

interface Order {
  code: string;
  name: string;
  date: string;
  channel: string;
  amount: number;
  status: string;
}

@Component({
  selector: 'app-store-sales',
  standalone: true,
  imports: [TableModule, CommonModule, BadgeModule, IconFieldModule, InputIconModule, DatePickerModule, FormsModule, FluidModule, ReactiveFormsModule, InputTextModule, DialogModule, ButtonModule, ToggleSwitchModule, SelectModule, ToastModule, SplitButton, TagModule],
  templateUrl: './store-sales.component.html',
  styleUrl: './store-sales.component.scss'
})
export class StoreSalesComponent {

  @ViewChild('dt') dt!: Table;

  payments: Payment[] = [];
  paymentForm!: FormGroup;
  isPartialPayment = false;
  filteredOrders: Order[] = [];
  requiresReceiptNumber = false;
  loading = false;
  startDate: string = '';
  endDate: string = '';
  orders: Order[] = [];
  shopId: string | null = null;
  currency: string = '';
  fullOrders: any[] = [];
  orderOptions: any[] = [
    {
      label: 'Reenviar Comprobante',
      command: () => {
          this.reSendSaleMail();
      }
    },
    // {
    //   label: 'Ver Logs',
    //   command: () => {
    //       this.delete();
    //   }
    // },
    // { separator: true }
  ];

  constructor(
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    public lambdaService: LambdaService,
    private route: ActivatedRoute,
    private smessageService: MessageService
  ) {

    const today = new Date();
    this.shopId = this.route.snapshot.paramMap.get('id');


  }

  ngOnInit() {
    this.payments = [
      { name: 'Tarjeta de Crédito', value: '1' },
      { name: 'SINPE Móvil', value: '2' },
      { name: 'Transferencia Bancaria', value: '3' },
      { name: 'Efectivo', value: '4' },
    ];
    const today = new Date();
    const startDate = new Date();
    startDate.setDate(today.getDate() - 90);
    this.startDate = format(startDate, 'yyyy-MM-dd');
    this.endDate = format(today, 'yyyy-MM-dd');
    this.getSales();
    this.currency = 'CRC'

  }

  async getSales() {
    this.loading = true;
    const shopId = this.shopId;

    await this.lambdaService
    .getShopSales(Number(shopId), '', 0, 100, this.startDate, this.endDate, '0', -1)
    .then((data: any) => {
      if (data.sales) {
        this.fullOrders = data.sales;
        console.log(this.fullOrders)
        this.orders = data.sales.map((sale: any) => {
          return {
            code: sale.saleOrderCode,
            name: sale.clientName,
            date: sale.saleDate ? format(new Date(sale.saleDate), 'yyyy/MM/dd hh:mm a') : '',
            channel: this.getChannel(sale.channelId),
            amount: this.getTotalAmount(sale),
            status: this.getStatus(Number(sale.saleState)),
          };
        });

        this.filteredOrders = [...this.orders];
      }
      this.loading = false;
    })
    .catch((error: any) => {
        console.error('Error fetching sales:', error);
        this.loading = false;
    });

    this.cd.detectChanges();
  }

  getChannel(channelId: number): string {
    switch (channelId) {
      case 1:
          return 'Online';
      case 2:
          return 'POS';
      default:
          return 'Desconocido';
    }
  }

  getTotalAmount(sale: any): number {
    return sale?.saleEndPrice || 0;
  }

  getStatus(saleState: number | null | undefined): { description: string; color: string } {
    if (saleState === null || saleState === undefined || isNaN(saleState)) {
      return { description: 'Desconocido', color: 'bg-white text-black' };
    }

    switch (saleState) {
      case 0:
        return { description: 'Cancelado', color: 'error' };
      case 1:
        return { description: 'Pendiente de verificación', color: 'warn' };
      case 2:
        return { description: 'Preparando orden', color: 'info' };
      case 3:
        return { description: 'Entregado', color: 'success' };
      case 4:
        return { description: 'Pendiente Compra Click', color: 'secondary' };
      case 5:
        return { description: 'Completado', color: 'success' };
      case 6:
        return { description: 'Parcial', color: 'warn' };
      default:
        return { description: 'Desconocido', color: 'contrast' };
    }
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement; // Afirmación de tipo
    console.log(input.value, "searching")
    this.dt.filterGlobal(input.value, 'contains'); // Usa el valor del input
  }

  reSendSaleMail() {
    console.log("resend")
    this.smessageService.add({ severity: 'success', summary: 'Éxito', detail: 'Comprobante reenviado con éxito' });
  }

  update() {
    console.log("update")
    this.smessageService.add({ severity: 'success', summary: 'Success', detail: 'Data Updated' });
  }

  delete() {
    console.log("delete")
    this.smessageService.add({ severity: 'success', summary: 'Success', detail: 'Data Deleted' });
  }

}
